import axios from 'axios'
import authHeader from './auth-header'

class CentralFamiliaService {
  listarAjustesCadastrais(status = 'pendente') {
    const query = status ? `?status=${status}` : ''
    return axios.get(process.env.VUE_APP_API_URL + `central-familia/ajustes-cadastrais${query}`, { headers: authHeader() })
  }

  obterComprovante(idSolicitacao, section) {
    return axios.get(process.env.VUE_APP_API_URL + `central-familia/ajustes-cadastrais/${idSolicitacao}/comprovantes/${section}`, { headers: authHeader(), timeout: 30000 })
  }

  aprovarAjusteCadastral(idSolicitacao) {
    return axios.post(process.env.VUE_APP_API_URL + `central-familia/ajustes-cadastrais/${idSolicitacao}/aprovar`, {}, { headers: authHeader() })
  }

  reprovarAjusteCadastral(idSolicitacao, justificativa) {
    return axios.post(
      process.env.VUE_APP_API_URL + `central-familia/ajustes-cadastrais/${idSolicitacao}/reprovar`,
      { justificativa },
      { headers: authHeader() }
    )
  }
}

export default new CentralFamiliaService()
